/* Atelier Lecture — barre de progression de lecture. Sans dependance, leger. */
(function () {
  'use strict';
  if (window.__alEngagement) return;
  window.__alEngagement = true;

  function init() {
    var content = document.querySelector('.article-content');
    if (!content) return;

    var style = document.createElement('style');
    style.id = 'al-engagement-css';
    style.textContent =
      '.al-progress{position:fixed;top:0;left:0;width:100%;height:3px;z-index:9999;pointer-events:none;background:transparent;}' +
      '.al-progress__fill{display:block;height:100%;width:0;background:#b8844a;}';
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.className = 'al-progress';
    var fill = document.createElement('span');
    fill.className = 'al-progress__fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      ticking = false;
      var rect = content.getBoundingClientRect();
      var total = content.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      fill.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
